import moment from 'moment-timezone';

const timezoneValues: { value: string; name: string; selected?: boolean }[] = [
    {
        value: 'US/Samoa',
        name: 'Samoa [GMT-11:00]'
    },
    {
        value: 'US/Hawaii',
        name: 'Hawaii [GMT-10:00]'
    },
    {
        value: 'US/Alaska',
        name: 'Alaska [GMT-09:00]'
    },
    {
        value: 'US/Pacific',
        name: 'Pacific Time [GMT-08:00]'
    },
    {
        value: 'America/Vancouver',
        name: 'Vancouver [GMT-08:00]'
    },
    {
        value: 'US/Mountain',
        name: 'Mountain Time [GMT-07:00]'
    },
    {
        value: 'America/Phoenix',
        name: 'Phoenix [GMT-07:00]'
    },
    {
        value: 'Canada/Saskatchewan',
        name: 'Saskatchewan [GMT-06:00]'
    },
    {
        value: 'US/Central',
        name: 'Central Time [GMT-06:00]'
    },
    {
        value: 'America/Costa_Rica',
        name: 'Costa Rica [GMT-06:00]'
    },
    {
        value: 'US/Eastern',
        name: 'Eastern Time [GMT-05:00]'
    },
    {
        value: 'America/Indiana/Indianapolis',
        name: 'Indianapolis [GMT-05:00]'
    },
    {
        value: 'America/Toronto',
        name: 'Toronto [GMT-05:00]'
    },
    {
        value: 'America/New_York',
        name: 'New York [GMT-05:00]'
    },
    {
        value: 'US/East-Indiana',
        name: 'Indiana (East) [GMT-05:00]'
    },
    {
        value: 'America/Bogota',
        name: 'Bogota [GMT-05:00]'
    },
    {
        value: 'America/Caracas',
        name: 'Caracas [GMT-04:30]'
    },
    {
        value: 'Canada/Atlantic',
        name: 'Atlantic Time [GMT-04:00]'
    },
    {
        value: 'America/Curacao',
        name: 'Curacao [GMT-04:00 DST]'
    },
    {
        value: 'America/Santiago',
        name: 'Santiago [GMT-04:00]'
    },
    {
        value: 'Canada/Newfoundland',
        name: 'Newfoundland [GMT-03:30]'
    },
    {
        value: 'America/Buenos_Aires',
        name: 'Buenos Aires [GMT-03:00]'
    },
    {
        value: 'America/Sao_Paulo',
        name: 'São Paulo [GMT-02:00]'
    },
    {
        value: 'Atlantic/Stanley',
        name: 'Stanley [GMT-02:00]'
    },
    {
        value: 'Atlantic/Cape_Verde',
        name: 'Cape Verde Is. [GMT-01:00]'
    },
    {
        value: 'Europe/Dublin',
        name: 'Dublin [GMT]'
    },
    {
        value: 'Europe/Lisbon',
        name: 'Lisbon [GMT]'
    },
    {
        value: 'Europe/London',
        name: 'London [GMT]'
    },
    {
        value: 'Europe/Amsterdam',
        name: 'Amsterdam [GMT+01:00]'
    },
    {
        value: 'Europe/Berlin',
        name: 'Berlin [GMT+01:00]'
    },
    {
        value: 'Europe/Brussels',
        name: 'Brussels [GMT+01:00]'
    },
    {
        value: 'Europe/Madrid',
        name: 'Madrid [GMT+01:00]'
    },
    {
        value: 'Europe/Paris',
        name: 'Paris [GMT+01:00]'
    },
    {
        value: 'Europe/Rome',
        name: 'Rome [GMT+01:00]'
    },
    {
        value: 'Europe/Stockholm',
        name: 'Stockholm [GMT+01:00]'
    },
    {
        value: 'Europe/Warsaw',
        name: 'Warsaw [GMT+01:00]'
    },
    {
        value: 'Europe/Athens',
        name: 'Athens [GMT+02:00]'
    },
    {
        value: 'Africa/Johannesburg',
        name: 'Johannesburg [GMT+02:00]'
    },
    {
        value: 'Europe/Bucharest',
        name: 'Bucharest [GMT+02:00]'
    },
    {
        value: 'Europe/Helsinki',
        name: 'Helsinki [GMT+02:00]'
    },
    {
        value: 'Asia/Jerusalem',
        name: 'Jerusalem [GMT+02:00]'
    },
    {
        value: 'Europe/Kiev',
        name: 'Kyiv [GMT+02:00]'
    },
    {
        value: 'Asia/Riyadh',
        name: 'Riyadh [GMT+03:00]'
    },
    {
        value: 'Asia/Tehran',
        name: 'Tehran [GMT+03:00]'
    },
    {
        value: 'Europe/Moscow',
        name: 'Moscow [GMT+04:00]'
    },
    {
        value: 'Asia/Dubai',
        name: 'Dubai [GMT+04:00]'
    },
    {
        value: 'Asia/Kabul',
        name: 'Kabul [GMT+04:30]'
    },
    {
        value: 'Asia/Karachi',
        name: 'Karachi [GMT+05:00]'
    },
    {
        value: 'Asia/Kolkata',
        name: 'Kolkata [GMT+05:30]'
    },
    {
        value: 'Asia/Kathmandu',
        name: 'Kathmandu [GMT+05:45]'
    },
    {
        value: 'Asia/Yekaterinburg',
        name: 'Ekaterinburg [GMT+06:00]'
    },
    {
        value: 'Asia/Dhaka',
        name: 'Dhaka [GMT+06:00]'
    },
    {
        value: 'Asia/Yangon',
        name: 'Yangon [GMT+06:30]'
    },
    {
        value: 'Asia/Bangkok',
        name: 'Bangkok [GMT+07:00]'
    },
    {
        value: 'Asia/Jakarta',
        name: 'Jakarta [GMT+07:00]'
    },
    {
        value: 'Asia/Chongqing',
        name: 'Chongqing [GMT+08:00]'
    },
    {
        value: 'Asia/Hong_Kong',
        name: 'Hong Kong [GMT+08:00]'
    },
    {
        value: 'Asia/Kuala_Lumpur',
        name: 'Kuala Lumpur [GMT+08:00]'
    },
    {
        value: 'Australia/Perth',
        name: 'Perth [GMT+08:00]'
    },
    {
        value: 'Asia/Singapore',
        name: 'Singapore [GMT+08:00]'
    },
    {
        value: 'Asia/Taipei',
        name: 'Taipei [GMT+08:00]'
    },
    {
        value: 'Asia/Seoul',
        name: 'Seoul [GMT+09:00]'
    },
    {
        value: 'Asia/Tokyo',
        name: 'Tokyo [GMT+09:00]'
    },
    {
        value: 'Australia/Adelaide',
        name: 'Adelaide [GMT+09:30]'
    },
    {
        value: 'Australia/Darwin',
        name: 'Darwin [GMT+09:30]'
    },
    {
        value: 'Pacific/Guam',
        name: 'Guam [GMT+10:00]'
    },
    {
        value: 'Australia/Brisbane',
        name: 'Brisbane [GMT+10:00]'
    },
    {
        value: 'Australia/Melbourne',
        name: 'Melbourne [GMT+10:00]'
    },
    {
        value: 'Australia/Sydney',
        name: 'Sydney [GMT+10:00]'
    },
    {
        value: 'Asia/Vladivostok',
        name: 'Vladivostok [GMT+10:00]'
    },
    {
        value: 'Pacific/Auckland',
        name: 'Auckland [GMT+12:00]'
    },
    {
        value: 'Pacific/Fiji',
        name: 'Fiji [GMT+12:00]'
    }
];

export const TIMEZONES = timezoneValues.map((timezone) => {
    const regex = /\/(.+)$/;
    const valueToName = timezone.value.match(regex);
    const prettifiedName = valueToName[1].replace('_', ' ');

    const offset = moment().tz(timezone.value).format('Z');
    const nameWithOffset = `${prettifiedName} [GMT${offset}]`;

    return {
        value: timezone.value,
        name: nameWithOffset
    };
});
